import React from "react";
import { jwtDecode } from "jwt-decode";
import { connect, useDispatch } from "react-redux";
import { showModal, TOKEN_KEY } from "../actions";
import { logout } from "actions";
import { SESSION_EXPIRE_MODAL } from "./modals";
import { URLS } from "../constants";

export const TOKEN_EXPIRY_WARNING_SECONDS = 60;

export const SessionMonitor = () => {
  const dispatch = useDispatch();
  const [hasShownModal, setHasShownModal] = React.useState(false);

  React.useEffect(() => {
    const intervalId = setInterval(() => {
      const token = localStorage.getItem(TOKEN_KEY);
      if (!token) return;

      let exp;
      try {
        exp = jwtDecode(token).exp;
      } catch (e) {
        dispatch(logout());
        clearInterval(intervalId);
        return;
      }

      const now = Math.floor(Date.now() / 1000);
      const timeLeft = Math.floor(exp - now);

      if (timeLeft <= 0) {
        dispatch(logout(getRedirectLoginUrl()));
        clearInterval(intervalId);
      } else {
        if (timeLeft <= TOKEN_EXPIRY_WARNING_SECONDS) {
          if (!hasShownModal) {
            dispatch(showModal(SESSION_EXPIRE_MODAL));
            setHasShownModal(true);
          }
        } else {
          setHasShownModal(false); // reset if token got refreshed
        }
      }
    }, 1000);

    return () => clearInterval(intervalId);
  }, []);

  return null;
};

export const getRedirectLoginUrl = () => {
  const requestedUrl = typeof window.location.pathname === "string" ? window.location.pathname : "";
  return requestedUrl ? URLS.LOGIN + "next=" + requestedUrl : URLS.LOGIN;
};
